var exports = {
  "k": "x31de4314--7420bb--container",
  "i": "x31de4314--7420bb--wrapper",
};

module.exports = exports;
